<app-header [currentUrl] = "currentUrl" class="sticky"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="currentUrl !== '/'"></app-footer>